/**
 * The one-time handle for "Direkt zum Portal": the server hands it out once, in the answer to the submit. It is kept in
 * the `sessionStorage` of this tab only (never in `localStorage`, never in the address, never logged) and removed
 * as soon as it has been used or the server says it is no good. A page opened in another tab or browser has none -
 * the button is simply not offered there.
 */
const key = (token: string) => `onboarding.portal.${token}`;

export function storeHandle(token: string, handle: string): void {
  try {
    window.sessionStorage.setItem(key(token), handle);
  } catch {
    // no storage: no button, the e-mail still works
  }
}

export function readHandle(token: string): string | null {
  try {
    return window.sessionStorage.getItem(key(token));
  } catch {
    return null;
  }
}

export function clearHandle(token: string): void {
  try {
    window.sessionStorage.removeItem(key(token));
  } catch {
    // nothing to remove
  }
}
